import React from 'react';
import { toAbsoluteApiUrl } from '../../../helpers/http-client';

const getInitials = (text = '') => {
    const safeText = String(text || '').trim();
    if (!safeText) {
        return 'US';
    }

    const words = safeText.split(/\s+/).filter(Boolean);
    if (words.length === 1) {
        return words[0].slice(0, 2).toUpperCase();
    }

    return `${words[0][0] || ''}${words[1][0] || ''}`.toUpperCase();
};

export const UserAvatar = ({
    name = '',
    photoUrl = '',
    alt,
    className = 'user-avatar',
    fallbackClassName = 'user-avatar-fallback',
}) => {
    const normalizedUrl = React.useMemo(() => toAbsoluteApiUrl(photoUrl), [photoUrl]);
    const [hasImageError, setHasImageError] = React.useState(false);

    React.useEffect(() => {
        setHasImageError(false);
    }, [normalizedUrl]);

    if (!normalizedUrl || hasImageError) {
        return (
            <span className={fallbackClassName} aria-label={alt || name || 'Usuario'}>
                {getInitials(name)}
            </span>
        );
    }

    return (
        <img
            src={normalizedUrl}
            alt={alt || name || 'Usuario'}
            className={className}
            onError={() => setHasImageError(true)}
        />
    );
};
